module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[105]348.e568c73.woff2";